import React from 'react';

import { ZERO } from "@src/core/config";
import { useSearchParams } from "react-router-dom";

const QUERY_PAGE_KEY = 'page';

const usePagination = (initPage = ZERO) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const queryPage = Number(searchParams.get(QUERY_PAGE_KEY) ?? ZERO);

  const [page, setPage] = React.useState(queryPage ?? initPage);

  React.useEffect(() => {

    const updatedParams = new URLSearchParams(searchParams.toString());

    if (page > ZERO) updatedParams.set(QUERY_PAGE_KEY, page.toString());

    else updatedParams.delete(QUERY_PAGE_KEY);

    setSearchParams(updatedParams);

  }, [page, setPage]);

  return {
    page,
    setPage,
  };


};

export default usePagination;